Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.aLinkReset = void 0;
exports.aLinkReset = {
  ncss: {
    bg: 'transparent',
    boxSizing: 'border-box',
    cursor: 'pointer',
    fontFamily: 'text',
    '&:hover': {},
    '&:visited': {},
    '&:focus': {
      outlineColor: 'black',
      outlineOffset: 4,
      outlineWidth: 2,
      outlineStyle: 'dotted'
    },
    '&:active': {}
  }
};